import React from 'react';
import useBundleTranslation from 'i18n';

interface KPIsTwoTilesLayoutIconProps {
    width?: number;
    height?: number;
    className?: string;
}

export default function KPIsTwoTilesLayoutIcon({ width = 360, height = 216, className }: KPIsTwoTilesLayoutIconProps) {
    const { t } = useBundleTranslation('form');

    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 360 216"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <rect width="360" height="216" rx="4" fill="#00B4FF" fillOpacity="0.04" />
            <rect x="0.5" y="0.5" width="359" height="215" rx="3.5" stroke="#00B4FF" strokeOpacity="0.4" />

            {/* Hero Section */}
            <rect
                x="16.5"
                y="16.5"
                width="327"
                height="23"
                rx="3.5"
                fill="#00B4FF"
                fillOpacity="0.12"
                stroke="#00B4FF"
            />
            <text
                fill="#00B4FF"
                fillOpacity="0.56"
                xmlSpace="preserve"
                style={{ whiteSpace: 'pre' }}
                fontFamily="Inter"
                fontSize="10"
                letterSpacing="0px"
            >
                <tspan x="24" y="31.2727">
                    {t('builder_layouts.hero_section')}
                </tspan>
            </text>

            {/* Filters */}
            <rect
                x="16.5"
                y="48.5"
                width="327"
                height="23"
                rx="3.5"
                fill="#00B4FF"
                fillOpacity="0.12"
                stroke="#00B4FF"
            />
            <text
                fill="#00B4FF"
                fillOpacity="0.56"
                xmlSpace="preserve"
                style={{ whiteSpace: 'pre' }}
                fontFamily="Inter"
                fontSize="10"
                letterSpacing="0px"
            >
                <tspan x="24" y="63.2727">
                    {t('builder_layouts.filters')}
                </tspan>
            </text>

            {/* KPI 1 */}
            <rect
                x="16.5"
                y="80.5"
                width="155"
                height="119"
                rx="3.5"
                fill="#00B4FF"
                fillOpacity="0.12"
                stroke="#00B4FF"
            />
            <text
                fill="#00B4FF"
                fillOpacity="0.56"
                xmlSpace="preserve"
                style={{ whiteSpace: 'pre' }}
                fontFamily="Inter"
                fontSize="10"
                letterSpacing="0px"
            >
                <tspan x="83" y="144.273">
                    {t('builder_layouts.kpi_1')}
                </tspan>
            </text>

            {/* KPI 2 */}
            <rect
                x="188.5"
                y="80.5"
                width="155"
                height="119"
                rx="3.5"
                fill="#00B4FF"
                fillOpacity="0.12"
                stroke="#00B4FF"
            />
            <text
                fill="#00B4FF"
                fillOpacity="0.56"
                xmlSpace="preserve"
                style={{ whiteSpace: 'pre' }}
                fontFamily="Inter"
                fontSize="10"
                letterSpacing="0px"
            >
                <tspan x="255" y="144.273">
                    {t('builder_layouts.kpi_2')}
                </tspan>
            </text>
        </svg>
    );
}
